import React from 'react';
import { StickyBar } from './components/StickyBar';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { Reality } from './components/Reality';
import { SystemOverview } from './components/SystemOverview';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Scarcity } from './components/Scarcity';
import { Checkout } from './components/Checkout';
import { Faq } from './components/Faq';
import { Comparison } from './components/Comparison';
import { FinalCta } from './components/FinalCta';
import { MobileCtaBar } from './components/MobileCtaBar';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-full w-full bg-navy pb-20 font-sans text-white lg:pb-0" data-id="element-0" data-mp="28tmi1bqzgr1g">
      <StickyBar data-id="element-1" data-mp="23vunsb2v8su3" />
      <main data-id="element-2" data-mp="23u9ueosaffxt">
        <Hero data-id="element-3" data-mp="23ujho4ly78zt" />
        <SocialProof data-id="element-4" data-mp="23v2sl1d6kx4c" />
        <Testimonials data-id="element-5" data-mp="23ti5fwt74ggi" />
        <Reality data-id="element-6" data-mp="3ikha0f5th31m" />
        <SystemOverview data-id="element-7" data-mp="3iiwf2oflbi38" />
        <Volumes data-id="element-8" data-mp="3ijpbavgxap74" />
        <Bonuses data-id="element-9" data-mp="3ii4su47vuwpm" />
        <Scarcity data-id="element-10" data-mp="3mlawr57iwbsx" />
        <Checkout data-id="element-11" data-mp="3mkre1ma1tjdu" />
        <Comparison data-id="element-12" data-mp="3mk868ye44bdj" />
        <Faq data-id="element-13" data-mp="3mjq3rk0ux0x6" />
        <FinalCta data-id="element-14" data-mp="3mj6hjr46bqdc" />
      </main>
      <MobileCtaBar data-id="element-15" data-mp="3rbrbcsn2y3gv" />
    </div>;
}